import DatePicker from 'components/DatePickerStyled/DatePicker'
import Switch from 'components/Form/Switch'
import TextArea from 'components/Form/TextArea'
import Select from 'components/Select'
import { SelectInputDiv } from 'components/UIComponents/FormStyles'
import {
  LabelWrapper,
  SalaryFlex,
} from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/Components/CompensationDetails/style'
import { FormItem } from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/style'
import { TierInputNumber } from 'modules/Roles/NewRoleCreation/Partials/RolesForm/Partials/CtcJoblocation/Style/style'
import moment from 'moment'
import React, { useState } from 'react'

const TierPriceOption = [
  {
    id: 1,
    name: 'INR ₹',
    value: 'inr',
  },
]

const SalaryOptions = [
  {
    name: 'Per Annum',
    value: 'ANNUALLY',
  },
  {
    name: 'Per Month',
    value: 'MONTHLY',
  },
]

const CompensationDetails = ({
  dateFormat,
  onChangeSalary,
  form,
  singleRoleData,
}) => {

  const [bonus, setBonus] = useState(true)
  const disabledDate = current => {
    return current && current < moment()
  }

  return (
    <>
      <SalaryFlex>
        <FormItem ismargin>
          <LabelWrapper>Salary</LabelWrapper>
          <SelectInputDiv width="100%" borderleft={true}>
            <Select
              width="30%"
              OptionData={TierPriceOption}
              valueParam="value"
              bordered={false}
              defaultValue={'inr'}
              disabled={true}
            />
            <TierInputNumber
              width={'40vh'}
              height="48px"
              borderRadius={'0 8px 8px 0'}
              paddingTop={'7px'}
              name={'salary'}
              placeholder="Eg: 1,00,000"
              defaultValue={singleRoleData?.maxCompensation} 
              parser={value => value.replace(/\$\s?|(,*)/g, '')}
              onChange={val => {
                if (val === undefined || val === null) {
                  onChangeSalary(singleRoleData?.maxCompensation)
                } else {
                  onChangeSalary(
                    val > singleRoleData?.maxCompensation ? val : singleRoleData?.maxCompensation
                  )
                }
              }}
            />
          </SelectInputDiv>
        </FormItem>
        <FormItem ismargin name={'frequency'}>
          <LabelWrapper>Frequency</LabelWrapper>
          <Select
            width="160px"
            OptionData={SalaryOptions}
            valueParam="value"
            bordered={false}
            defaultValue={singleRoleData?.CTCPeriod}
            onChange={value =>
              form.setFieldsValue({
                frequency: value,
              })
            }
            disabled={true}
          />
        </FormItem>
      </SalaryFlex>

      <FormItem name={'bouns'}>
        <Switch
          label="Include Bouns"
          width={'30%'}
          checked={bonus}
          onChange={e => {
            form.setFieldsValue({
              bouns: e,
            })
            setBonus(e)
          }}
        />
      </FormItem>

      <FormItem>
        <LabelWrapper>Offer Expire Date *</LabelWrapper>
        <DatePicker
          width="100%"
          placeholder={'Add Offer Expire Date'}
          dateFormat={dateFormat}
          name={'offerExpireDate'}
          disabledDate={disabledDate}
          rules={[
            {
              required: true,
              message: 'Please select offer expire date!',
            },
          ]}
        />
      </FormItem>

      <FormItem>
        <LabelWrapper>Add Note</LabelWrapper>
        <TextArea placeholder="Add Note" labelName="Add Note" name={'note'} />
      </FormItem>
    </>
  )
}

export default CompensationDetails
